import React from "react";

// reactstrap components
import {
  Button,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Form,
} from "reactstrap";
// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import Sidebar2 from 'components/Navbars/Sidebar'
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import Grid from '@material-ui/core/Grid';
import MaterialTable from 'material-table';
import { appUrl } from '../../config';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { DialogTitle, Dialog, DialogActions, DialogContent, Typography, CardActionArea } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CallMadeIcon from '@material-ui/icons/CallMade';
import Tooltip from '@material-ui/core/Tooltip';
import SendIcon from '@material-ui/icons/Send';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import SelectPRO from 'react-select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { isThrowStatement } from "typescript";

class Options extends React.Component {

  constructor(props) {
    super(props);
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.state = {
      firstFocus: false,
      option: "",
      columnsusers: [
        { title: 'Nombre', field: 'name' },
        {
          title: 'Empresa',
          field: 'emp', lookup: {}
        },
        { title: 'E-Mail', field: 'mail' },
        { title: 'Cédula', field: 'cc' },
        { title: 'Perfil', field: 'profile', lookup: { admin: 'Admin', standard: 'Standard' }, },
        { title: 'Estado', field: 'status', lookup: { activo: 'Activo', inactivo: 'Inactivo' }, },

      ],
      columnreceived: [
        { title: 'De', field: 'from.name' },
        { title: 'Empresa', field: 'emp.name' },
        { title: 'Asunto', field: 'subject' },
        { title: 'Fecha', field: 'date' },
        { title: 'Estado', field: 'status' },

      ],
      columnreceived2: [
        { title: 'De', field: 'from.name' },
        { title: 'Asunto', field: 'subject' },
        { title: 'Fecha', field: 'date' },
        { title: 'Estado', field: 'status' },

      ],
      columnsend: [
        { title: 'Para', field: 'to.name' },
        { title: 'Empresa', field: 'emp.name' },
        { title: 'Asunto', field: 'subject' },
        { title: 'Fecha', field: 'date' },

      ],
      columnsend2: [
        { title: 'Para', field: 'to.name' },
        { title: 'Asunto', field: 'subject' },
        { title: 'Fecha', field: 'date' },
      ],
      users: [],
      columnsemp: [
        { title: 'Nombre', field: 'name' },
        { title: 'Estado', field: 'status', lookup: { activo: 'Activo', inactivo: 'Inactivo' }, },
      ],
      columnstemas: [
        { title: 'Nombre', field: 'name' },
      ],
      emps: [],
      admin: false,
      toemps: {},
      tosend: {},
      filterusers: [],
      open: false,
      open1: false,
      open2: false,
      msgtosend: "",
      mymsgsfrom: [],
      mymsgsto: [],
      subject: "",
      enablemsg: false,
      enableto: false,
      mailselected: {},
      empselected: "",
      nameselected: "",
      tosend: {},
      filteradmins: [],
      openrespond: false,
      topics: [],
      auxlisttopics: [],
      topicselected: {},
      descorta: "",
      deslarga: "",
      open4: false,
      open5: false,
      quesfromtopic: [],
      showques: false,
      newques: false,
      quesselectes: "",
      requeriments: [],
      showform: false,
      newform: false,
      requeselected: {},
      fondo: "",
      cel: "",
      genero: "",
      regimen: "",
      pensiontemprana: "",
      semanas: "",
      cuenta: "",
      voluntarios: "",
      volutariospo: "",
      capitaliza: "",
      blinda: "",
      salario: "",
      bono: "",
      statusreq: "Creado",
      showreqs: false,
      name: this.props.user.name,
      cc: this.props.user.cc,
      emp: this.props.user.emp,
      mail: this.props.user.mail,
      products: [],
      open6: false,
      nameproduct: "",
      desproduct: "",
      showprod: false,
      newprod: false,
      productselected: {}
    };
  }

  handleChangetype = name => event => {
    console.log("name", event.target.value)
    this.setState({ [name]: event.target.value });
    if (name == "toemps") {
      var filterusers = this.state.users.filter(function (value) {
        return value.emp == event.target.value.name;
      });
      if (filterusers.length > 0) {
        this.setState({ filterusers: filterusers, enableto: true })
      } else {
        this.setState({ open: true, msgdiag: "No hay usuarios asociados a la empresa seleccionada", enableto: false })
      }
    } else if (name == "tosend") {
      this.setState({ enablemsg: true })
    }
  };

  handleOpenSettings = (rowData) => {
    console.log("opendv" + rowData.emp.name)
    this.setState({ mailselected: rowData, open2: true, empselected: rowData.emp.name, nameselected: rowData.to.name })
    if (rowData.tomail == this.props.user.mail) {
      fetch(appUrl + '/updatestatusmg', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          msg: rowData
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            console.log(data)
            this.getMessages()
          } else {
            //console.log("Error")
          }
        });
    }

  }

  getUsers = () => {
    fetch(appUrl + '/getusers', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          var users = data.users
          var filteradmins = users.filter(function (value) {
            return value.profile == "admin";
          });
          this.setState({ users: users, filteradmins: filteradmins })

        } else {
          //console.log("Error")
        }
      });
  }

  getProducts = () => {
    fetch(appUrl + '/getproducts', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          var products = data.products
          this.setState({ products: products })

        } else {
          //console.log("Error")
        }
      });
  }
  getRequeriments = () => {
    fetch(appUrl + '/getrequeriments', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          var requeriments = data.requeriments
          console.log("requeriments", requeriments.length)
          var requeriments2 = []
          var usermail = this.props.user.mail
          if (requeriments.length > 0) {
            var showreqs = true
          } else {
            var showreqs = false
          }
          if (!this.props.admin) {
            for (var i = 0; i < requeriments.length; i++) {
              if (requeriments[i].mail == usermail) {
                requeriments2.push(requeriments[i])
              }
            }
            this.setState({ requeriments: requeriments2, showreqs: showreqs })
          } else {
            this.setState({ requeriments: requeriments, showreqs: showreqs })
          }
        } else {
          //console.log("Error")
        }
      });
  }

  getTopics = () => {
    fetch(appUrl + '/gettopics', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          var auxlisttopics = []
          for (var i = 0; i < data.topics.length; i++) {
            auxlisttopics.push({ value: data.topics[i]._id, label: data.topics[i].name })
          }
          this.setState({ topics: data.topics, auxlisttopics: auxlisttopics })
        } else {
          //console.log("Error")
        }
      });
  }


  handleOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  }
  handleOpen1 = () => {
    this.setState({ open1: true });
  }
  handleClose1 = () => {
    this.setState({ open1: false, tosend: {}, toemps: {}, msgtosend: "", subject: "" });
  }

  handleClose2 = () => {
    this.setState({ open2: false, tosend: {}, toemps: {}, msgtosend: "", subject: "" });
  }

  handleOpen3 = () => {
    this.setState({ open3: true, newques: true });
  }

  handleClose3 = () => {
    this.setState({ open3: false, showques: false })
  }

  handleOpen4 = () => {
    this.setState({ open4: true, });
  }

  handleClose4 = () => {
    this.setState({ open4: false });
  }

  handleOpen6 = () => {
    this.setState({ open6: true, newprod: true });
  }

  handleClose6 = () => {
    this.setState({ open6: false, showprod: false });
  }

  handleOpenFormulario = () => {
    this.setState({ open5: true, newform: true });
  }

  handleCloseFormulario = () => {
    this.setState({
      open5: false, cel: "",
      fondo: "",
      genero: "",
      regimen: "",
      pensiontemprana: "",
      semanas: "",
      cuenta: "",
      voluntarios: "",
      volutariospo: "",
      capitaliza: "",
      blinda: "",
      salario: "",
      bono: "", showform: false
    });
  }

  handleOpenDetailQues = (option) => {
    this.setState({ open3: true, showques: true, quesselectes: option._id, descorta: option.descorta, deslarga: option.deslarga, respuesta: option.respuesta });
  }

  handleOpenDetailProduct = (event, option) => {
    this.setState({ open6: true, showprod: true, productselected: option, nameproduct: option.name, desproduct: option.description });
  }

  handleOpenDetailForm = (event, option) => {
    this.setState({
      open5: true,
      showform: true,
      requeselected: option,
      name: option.name,
      cc: option.cc,
      emp: option.emp,
      mail: option.mail,
      cel: option.cel,
      fondo: option.fondo,
      genero: option.genero,
      regimen: option.regimen,
      pensiontemprana: option.pensiontemprana,
      semanas: option.semanas,
      cuenta: option.cuenta,
      voluntarios: option.voluntarios,
      volutariospo: option.volutariospo,
      capitaliza: option.capitaliza,
      blinda: option.blinda,
      salario: option.salario,
      bono: option.bono,
      date: option.date,
      statusreq: option.status
    });
  }

  handleUpdateReq = () => {
    var id = this.state.requeselected._id
    var reque = {
      _id: id,
      name: this.props.user.name,
      mail: this.props.user.mail,
      cc: this.props.user.cc,
      emp: this.props.user.emp,
      cel: this.state.cel,
      fondo: this.state.fondo,
      genero: this.state.genero,
      regimen: this.state.regimen,
      pensiontemprana: this.state.pensiontemprana,
      semanas: this.state.semanas,
      cuenta: this.state.cuenta,
      voluntarios: this.state.voluntarios,
      volutariospo: this.state.volutariospo,
      capitaliza: this.state.capitaliza,
      blinda: this.state.blinda,
      salario: this.state.salario,
      bono: this.state.bono,
      status: this.state.statusreq
    }
    console.log("reque", reque)
    fetch(appUrl + '/updatereque', {
      method: 'post',
      body: JSON.stringify({
        reque: reque,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, requeselected: {} })
          this.handleCloseFormulario()
          this.getRequeriments()
        } else {
          this.setState({ open: true, msgdiag: data.message, requeselected: {} })
          this.handleCloseFormulario()

        }
      });
  }
  handleUpdateQues = () => {
    var ques = {
      id: this.state.quesselectes,
      topic: this.state.topicselected.value,
      descorta: this.state.descorta,
      deslarga: this.state.deslarga,
      respuesta: this.state.respuesta
    }
    fetch(appUrl + '/updateques', {
      method: 'post',
      body: JSON.stringify({
        ques: ques,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, descorta: "", deslarga: "", quesselectes: "", respuesta: "" })
          this.handleClose3()
          fetch(appUrl + '/getansfromtopic', {
            method: 'post',
            body: JSON.stringify({
              topic: ques.topic,
            }),
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(response => response.json())
            .then(data => {
              if (data.success) {
                console.log("Answers");
                this.setState({ quesfromtopic: data.questions })
              } else {
                console.log("No answers")
                this.setState({ quesfromtopic: [] })
              }
            });
        } else {
          this.setState({ open: true, msgdiag: data.message, descorta: "", deslarga: "", quesselectes: "", respuesta: "" })
          this.handleClose3()
        }
      });
  }

  handleUpdateProduct = () => {
    var product = {
      _id: this.state.productselected._id,
      name: this.state.nameproduct,
      description: this.state.desproduct,
    }
    fetch(appUrl + '/updateproduct', {
      method: 'post',
      body: JSON.stringify({
        product: product,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, desproduct: "", nameproduct: "", newprod: false })
          this.handleClose6()
          this.getProducts()

        } else {
          this.setState({ open: true, msgdiag: data.message, desproduct: "", nameproduct: "", newprod: false })
          this.handleClose6()
        }
      });
  }

  getEmps = () => {
    fetch(appUrl + '/getemps', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          var emps = data.emps
          var columns = this.state.columnsusers
          var dict = { "All": "All" }; // create an empty array
          for (var i = 0; i < data.emps.length; i++) {
            dict["" + data.emps[i].name + ""] = data.emps[i].name
            console.log("dic", dict, emps[4])
            columns[1].lookup = dict
          }
          this.setState({ columnsusers: columns })
          this.setState({ emps: emps })

        } else {
          //console.log("Error")
        }
      });
  }

  getMessages = () => {
    var usermail = this.props.user.mail
    fetch(appUrl + '/getmessages', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        usermail: usermail
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data.messages)
          var mymsgs = data.messages
          for (var i = 0; i < mymsgs.length; i++) {
            if (mymsgs[i].status == "send") {
              mymsgs[i].status = <CheckIcon style={{ fontSize: 50 }} />
            } if (mymsgs[i].status == "visto") {
              mymsgs[i].status = <DoneAllIcon style={{ fontSize: 50, color: "blue" }} />
            }
          }
          var mymsgsfrom = data.messages.filter(function (value) {
            return (value.frommail == usermail && value.para == usermail);
          });
          var mymsgsto = data.messages.filter(function (value) {
            return (value.tomail == usermail && value.para == usermail);
          });
          console.log("mymsgsfrom", mymsgsfrom, mymsgsto)
          this.setState({ mymsgsfrom: mymsgsfrom, mymsgsto: mymsgsto })
        } else {
          //console.log("Error")
        }
      });
  }

  componentDidMount() {
    console.log("props", this.props.admin)
    //this.setState({admin:this.props.admin})
    this.getUsers()
    this.getEmps()
    this.getMessages()
    this.getTopics()
    this.getRequeriments()
    this.getProducts()
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }

  handleChangeOption(event) {
    this.setState({ option: event });
  }

  UpdateEmp = (emp) => {
    console.log("hola", emp)
    fetch(appUrl + '/updateemp', {
      method: 'post',
      body: JSON.stringify({
        emp: emp,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("updated");
          this.getEmps();
        } else {
          console.log("Error updated")
        }
      });
  };


  UpdateUsers = (users) => {
    console.log("updateuser", users)
    fetch(appUrl + '/updateuser', {
      method: 'post',
      body: JSON.stringify({
        user: users,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("updated");
          this.getUsers();
        } else {
          console.log("Error updated")
        }
      });
  };
  handleSaveQues = () => {
    var ques = {
      topic: this.state.topicselected.value,
      descorta: this.state.descorta,
      deslarga: this.state.deslarga,
      respuesta: this.state.respuesta
    }
    fetch(appUrl + '/addquestion', {
      method: 'post',
      body: JSON.stringify({
        ques: ques
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, descorta: "", deslarga: "", quesselectes: "", respuesta: "" })
          this.handleClose3()
          fetch(appUrl + '/getansfromtopic', {
            method: 'post',
            body: JSON.stringify({
              topic: ques.topic,
            }),
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(response => response.json())
            .then(data => {
              if (data.success) {
                console.log("Answers");
                this.setState({ quesfromtopic: data.questions })
              } else {
                console.log("No answers")
                this.setState({ quesfromtopic: [] })
              }
            });
        } else {
          this.setState({ open: true, msgdiag: data.message, descorta: "", deslarga: "", quesselectes: "", respuesta: "" })
          this.handleClose3()

        }
      });
  }

  handleSaveProduct = () => {
    var product = {
      name: this.state.nameproduct,
      description: this.state.desproduct,
    }
    fetch(appUrl + '/addproduct', {
      method: 'post',
      body: JSON.stringify({
        product: product
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, desproduct: "", nameproduct: "", newprod: false })
          this.handleClose6()
          this.getProducts()
        } else {
          this.setState({ open: true, msgdiag: data.message, desproduct: "", nameproduct: "", newprod: false })
          this.handleClose6()
        }
      });
  }

  handleSaveReq = () => {
    var date = new Date();
    date = date.toLocaleDateString() + " " + date.toLocaleTimeString()
    var reque = {
      name: this.props.user.name,
      mail: this.props.user.mail,
      cc: this.props.user.cc,
      emp: this.props.user.emp,
      cel: this.state.cel,
      fondo: this.state.fondo,
      genero: this.state.genero,
      regimen: this.state.regimen,
      pensiontemprana: this.state.pensiontemprana,
      semanas: this.state.semanas,
      cuenta: this.state.cuenta,
      voluntarios: this.state.voluntarios,
      volutariospo: this.state.volutariospo,
      capitaliza: this.state.capitaliza,
      blinda: this.state.blinda,
      salario: this.state.salario,
      bono: this.state.bono,
      date: date,
      status: "Creado"
    }
    fetch(appUrl + '/addrequeriment', {
      method: 'post',
      body: JSON.stringify({
        reque: reque,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("addrequeriment", data)
          this.setState({ open: true, msgdiag: data.message, newform: false })

          this.handleCloseFormulario()
          this.getRequeriments()
        } else {
          this.setState({ open: true, msgdiag: data.message, newform: false })
          this.handleCloseFormulario()
        }
        this.setState({
          cel: "",
          fondo: "",
          genero: "",
          regimen: "",
          pensiontemprana: "",
          semanas: "",
          cuenta: "",
          voluntarios: "",
          volutariospo: "",
          capitaliza: "",
          blinda: "",
          salario: "",
          bono: ""
        })
      });
  }
  handleSave = () => {
    var date = new Date();
    date = date.toLocaleDateString() + " " + date.toLocaleTimeString()
    console.log("new Date(date).toISOString()", new Date(date))
    if (this.props.user.profile == "admin" && this.state.tosend.profile !== "admin") {
      var msg = {
        tomail: this.state.tosend.mail,
        frommail: this.props.user.mail,
        from: this.props.user,
        to: {
          name
            : this.state.tosend.name,
          mail
            : this.state.tosend.mail,
          profile
            : this.state.tosend.profile
        },
        emp: this.state.toemps,
        msg: this.state.msgtosend,
        subject: this.state.subject,
        date: date,
        status: "send"
      }
    } else if (this.props.user.profile !== "admin" && this.state.tosend.profile == "admin") {
      var msg = {
        tomail: this.state.tosend.mail,
        frommail: this.props.user.mail,
        from: this.props.user,
        to: {
          name
            : this.state.tosend.name,
          mail
            : this.state.tosend.mail,
          profile
            : this.state.tosend.profile
        },
        emp: { name: "All" },
        msg: this.state.msgtosend,
        subject: this.state.subject,
        date: date,
        status: "send"
      }
    } else {
      var msg = {
        tomail: this.state.tosend.mail,
        frommail: this.props.user.mail,
        from: this.props.user,
        to: {
          name
            : this.state.tosend.name,
          mail
            : this.state.tosend.mail,
          profile
            : this.state.tosend.profile
        },
        emp: { name: "All" },
        msg: this.state.msgtosend,
        subject: this.state.subject,
        date: date,
        status: "send"
      }
    }

    fetch(appUrl + '/addmessage', {
      method: 'post',
      body: JSON.stringify({
        msg: msg
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, tosend: {}, msgtosend: "", toemps: {}, enablemsg: false, enableto: false })
          this.handleClose1()

        } else {
          this.setState({ open: true, msgdiag: data.message, tosend: {}, msgtosend: "", toemps: {}, enablemsg: false, enableto: false })
          this.handleClose1()

        }
        this.getMessages()
      });
  }

  addingUser = (user) => {
    console.log("hola", user)
    fetch(appUrl + '/adduser', {
      method: 'post',
      body: JSON.stringify({
        user: user,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("added");
          this.getUsers();

        } else {
          console.log("Error ")
        }
      });
  };

  addingTopic = (topic) => {
    console.log("hola", topic)
    fetch(appUrl + '/addtopic', {
      method: 'post',
      body: JSON.stringify({
        topic: topic,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("added");
          this.getTopics();
        } else {
          console.log("Error ")
        }
      });
  };
  handleChange = selectedOption => {
    console.log(`Option selected:`, selectedOption);
    this.setState({ topicselected: selectedOption });
    fetch(appUrl + '/getansfromtopic', {
      method: 'post',
      body: JSON.stringify({
        topic: selectedOption.value,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("Answers");
          this.setState({ quesfromtopic: data.questions })
        } else {
          console.log("No answers")
          this.setState({ quesfromtopic: [] })
        }
      });

  };
  
  addingEmp = (emp) => {
    console.log("hola", emp)
    fetch(appUrl + '/addemp', {
      method: 'post',
      body: JSON.stringify({
        emp: emp,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("added");
          this.getEmps();
        } else {
          console.log("Error ")
        }
      });
  };

  removeUser = (user) => {
    console.log("remove my user", user)
    fetch(appUrl + '/removeuser', {
      method: 'post',
      body: JSON.stringify({
        user: user,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("removed");
          this.getUsers();
        } else {
          console.log("Error removed")
        }
      });
  };

  removeProduct = () => {
    fetch(appUrl + '/removeproduct', {
      method: 'post',
      body: JSON.stringify({
        product: this.state.productselected,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, desproduct: "", nameproduct: "", newprod: false })
          this.handleClose6()
          this.getProducts()
        } else {
          this.setState({ open: true, msgdiag: data.message, desproduct: "", nameproduct: "", newprod: false })
          this.handleClose6()
          this.getProducts()
        }
      });
  };

  handleRemoveQues = () => {
    console.log("remove question", this.state.topicselected)
    fetch(appUrl + '/removeques', {
      method: 'post',
      body: JSON.stringify({
        ques: this.state.quesselectes,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("removed");
          this.setState({ open: true, msgdiag: data.message, descorta: "", deslarga: "", quesselectes: "", respuesta: "" })
          fetch(appUrl + '/getansfromtopic', {
            method: 'post',
            body: JSON.stringify({
              topic: this.state.topicselected.value,
            }),
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(response => response.json())
            .then(data => {
              if (data.success) {
                console.log("Answers");
                this.setState({ quesfromtopic: data.questions })
              } else {
                console.log("No answers")
                this.setState({ quesfromtopic: [] })
              }
            });
          this.handleClose3()
        } else {
          this.setState({ open: true, msgdiag: data.message, descorta: "", deslarga: "", quesselectes: "", respuesta: "" })
          console.log("Error removed")
        }
      });
  };


  handleRemoveReq = () => {
    console.log("remove requeriment", this.state.requeselected)
    fetch(appUrl + '/removerequeriment', {
      method: 'post',
      body: JSON.stringify({
        ques: this.state.requeselected,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.setState({
            open: true, msgdiag: data.message, requeselected: {}, showform: false,
            cel: "",
            fondo: "",
            genero: "",
            regimen: "",
            pensiontemprana: "",
            semanas: "",
            cuenta: "",
            voluntarios: "",
            volutariospo: "",
            capitaliza: "",
            blinda: "",
            salario: "",
            bono: ""
          })

          this.handleCloseFormulario()
        } else {
          this.setState({ open: true, msgdiag: data.message, requeselected: {}, showform: false })
          this.handleCloseFormulario()
        }
        this.getRequeriments()

      });
  };

  removeEmp = (emp) => {
    console.log("remove my emp", emp)
    fetch(appUrl + '/removeemp', {
      method: 'post',
      body: JSON.stringify({
        emp: emp,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("removed");
          this.getEmps();
        } else {
          console.log("Error removed")
        }
      });
  };


  removeMessage = (message) => {
    console.log("remove my message", message)
    fetch(appUrl + '/removemsg', {
      method: 'post',
      body: JSON.stringify({
        message: message,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("removed");
          this.getMessages();
        } else {
          console.log("Error removed")
        }
      });
  };

  removeTopic = (topic) => {
    console.log("remove topic", topic)
    fetch(appUrl + '/removetopic', {
      method: 'post',
      body: JSON.stringify({
        topic: topic,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("removed");
          this.getTopics();
        } else {
          console.log("Error removed")
        }
      });
  };


  render() {
    return (
      <div>
        <ExamplesNavbar onChange={this.props.onChange} productselected={this.props.productselected} products={this.props.products} user={this.props.user} userstatus={this.props.userstatus} admin={this.props.admin} />
        <LandingPageHeader />
        <br></br>
        <Grid container spacing={10}>
          <Grid item>
            <Sidebar2 onChange={this.handleChangeOption} admin={this.props.admin} />
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" >
              {(this.state.option == "users") ?
                <Container>
                  <MaterialTable
                    title="Usuarios"
                    columns={this.state.columnsusers}
                    data={this.state.users}
                    editable={{
                      onRowAdd: newData =>
                        new Promise(resolve => {
                          setTimeout(() => {
                            resolve();
                            const data = this.state.users;
                            data.push(newData);
                            this.setState({ users: data });
                            this.addingUser(newData)
                          }, 600);
                        }),
                      onRowUpdate: (newData, oldData) =>
                        new Promise(resolve => {
                          setTimeout(() => {
                            resolve();
                            const data = this.state.users;
                            data[data.indexOf(oldData)] = newData;
                            this.setState({ users: data });
                            this.UpdateUsers(newData)
                          }, 600);
                        }),
                      onRowDelete: oldData =>
                        new Promise(resolve => {
                          setTimeout(() => {
                            resolve();
                            const data = [this.state.users];
                            data.splice(data.indexOf(oldData), 1);
                            console.log("delete", oldData)
                            this.setState({ users: data });
                            this.removeUser(oldData)
                          }, 600);
                        }),
                    }}

                  />
                  <br></br>
                  <br></br>
                </Container>
                : (this.state.option == "emp") ?
                  <Container>
                    <br></br>
                    <br></br>
                    <MaterialTable
                      title="Empresas"
                      columns={this.state.columnsemp}
                      data={this.state.emps}
                      editable={{
                        onRowAdd: newData =>
                          new Promise(resolve => {
                            setTimeout(() => {
                              resolve();
                              const data = this.state.emps;
                              data.push(newData);
                              this.setState({ emps: data });
                              this.addingEmp(newData)
                            }, 600);
                          }),
                        onRowUpdate: (newData, oldData) =>
                          new Promise(resolve => {
                            setTimeout(() => {
                              resolve();
                              const data = this.state.emps;
                              data[data.indexOf(oldData)] = newData;
                              this.setState({ emps: data });
                              this.UpdateEmp(newData)
                            }, 600);
                          }),
                        onRowDelete: oldData =>
                          new Promise(resolve => {
                            setTimeout(() => {
                              resolve();
                              const data = [this.state.emps];
                              data.splice(data.indexOf(oldData), 1);
                              console.log("delete", oldData)
                              this.setState({ emps: data });
                              this.removeEmp(oldData)
                            }, 600);
                          }),
                      }}
                    />
                    <br></br>
                    <br></br>
                  </Container> :
                  this.state.option == "ans" ?
                    <Container>
                      <Toolbar>
                        <Typography variant="h5" component="h6">
                          Temas:
                      </Typography>
                        <Tooltip title="Temas" aria-label="add">
                          <Fab color="info" aria-label="add" onClick={() => this.handleOpen4()} style={{ position: 'absolute', top: 4, right: 2 }}>
                            <ListAltIcon />
                          </Fab>
                        </Tooltip>
                      </Toolbar>
                      <SelectPRO
                        value={this.state.topicselected}
                        onChange={this.handleChange}
                        options={this.state.auxlisttopics}
                        fullWidth />
                      {Object.keys(this.state.topicselected).length !== 0 ?
                        <div>
                          <Card style={{ display: 'flex', width: 'auto', height: 'auto' }}>
                            <CardHeader title={"Preguntas para: " + this.state.topicselected.label} />
                            <Divider />
                            <CardContent style={{ flex: '1 0 auto' }}>
                              <Tooltip title="Adicionar pregunta" aria-label="add">
                                <Fab color="info" aria-label="add" onClick={() => this.handleOpen3()} style={{ position: 'relative', top: 4, right: 2 }}>
                                  <AddIcon />
                                </Fab>
                              </Tooltip>
                            </CardContent>
                            <Divider />
                          </Card>
                          <Card>
                            <CardContent>
                              <List>
                                {this.state.quesfromtopic.map(option => (
                                  <ListItem button onClick={(event, rowData) => this.handleOpenDetailQues(option)}>
                                    <ListItemText
                                      primary={
                                        <div>
                                          <Typography variant="h5" component="h5">
                                            {option.descorta}
                                          </Typography>
                                        </div>
                                      }
                                      secondary=""
                                    />
                                  </ListItem>
                                ))}

                              </List>

                            </CardContent>

                          </Card>
                        </div>
                        : null
                      }
                    </Container>
                    :
                    this.state.option == "products" ?
                      <Container>
                        <Toolbar>
                          <Typography variant="h5" component="h6">
                            Productos
                        </Typography>
                          <Tooltip title="Crear producto" aria-label="add">
                            <Fab color="info" aria-label="add" onClick={() => this.handleOpen6()} style={{ position: 'absolute', top: 4, right: 60 }}>
                              <ListAltIcon />
                            </Fab>
                          </Tooltip>
                        </Toolbar>
                        {this.state.products.length > 0 ?
                          <div>
                            <div className="text-center">
                              <div style={{ marginTop: 4 }}>
                                <Grid container spacing={5} >
                                  {this.state.products.map(list => (
                                    <Grid item lg={6} md={6} xs={12}>
                                      <Card>
                                        <CardActionArea onClick={event => this.handleOpenDetailProduct(event, list)}>
                                          <CardHeader>Cálculo Pensión</CardHeader>
                                          <CardContent>
                                            <Typography align="center" variant="h7" >
                                              Nombre: {list.name}
                                            </Typography>
                                            <Divider />
                                            <Typography align="center" variant="h7" >
                                              Descripción: {list.description}
                                            </Typography>
                                          </CardContent>
                                          <Divider />
                                          <CardActions>
                                            <Grid
                                              container
                                              justify="space-between"
                                            >
                                              <Grid
                                                style={{
                                                  display: 'flex',
                                                  alignItems: 'center'
                                                }}
                                                item
                                              >
                                                <Typography
                                                  display="inline"
                                                  variant="body1"
                                                >
                                                  Editar...
                                          </Typography>
                                              </Grid>
                                            </Grid>
                                          </CardActions>
                                        </CardActionArea>
                                      </Card>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                            </div>
                          </div>
                          : <div className="text-center">
                            <div style={{ marginTop: 4 }}>
                              <Grid container spacing={5} >
                                {this.state.requeriments.map(list => (
                                  <Grid item lg={6} md={6} xs={12}>
                                    <Typography align="center" variant="h3" >
                                      No hay Productos
                                </Typography>
                                  </Grid>
                                ))}
                              </Grid>
                            </div>
                          </div>
                        }
                      </Container>
                      :
                      this.state.option == "requeriments" ?
                        <Container>
                          <br></br>
                          <Toolbar>
                            <Typography variant="h5" component="h6">
                              Solicitudes cálculo de Pensión:
                            </Typography>
                            {!this.props.admin ?
                              <Tooltip title="Formulario para cálculo de pensión" aria-label="add">
                                <Fab color="info" aria-label="add" onClick={event => this.handleOpenFormulario()} style={{ position: 'absolute', top: 4, right: 50 }}>
                                  <ListAltIcon />
                                </Fab>
                              </Tooltip>
                              : null
                            }
                          </Toolbar>
                          {this.state.showreqs ?
                            <div className="text-center">
                              <div style={{ marginTop: 4 }}>
                                <Grid container spacing={5} >
                                  {this.state.requeriments.map(list => (
                                    <Grid item lg={6} md={6} xs={12}>
                                      <Card>
                                        <CardActionArea onClick={event => this.handleOpenDetailForm(event, list)}>
                                          <CardHeader>Cálculo Pensión</CardHeader>
                                          <CardContent>
                                            <Typography align="center" variant="h7" >
                                              Empresa: {list.emp}
                                            </Typography>
                                            <Divider />
                                            <Typography align="center" variant="h7" >
                                              Nombre: {list.name}
                                            </Typography>
                                            <Divider />
                                            <Typography align="center" variant="h7" >
                                              Correo: {list.mail}
                                            </Typography>
                                            <Divider />
                                            <Typography align="center" variant="h7" >
                                              {list.date}
                                            </Typography>
                                          </CardContent>
                                          <Divider />
                                          <CardActions>
                                            <Grid
                                              container
                                              justify="space-between"
                                            >
                                              <Grid
                                                style={{
                                                  display: 'flex',
                                                  alignItems: 'center'
                                                }}
                                                item
                                              >
                                                <Typography
                                                  display="inline"
                                                  variant="body1"
                                                >
                                                  Ver más...
                                          </Typography>
                                              </Grid>
                                            </Grid>
                                          </CardActions>
                                        </CardActionArea>
                                      </Card>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                            </div>
                            :
                            <div className="text-center">
                              <div style={{ marginTop: 4 }}>
                                <Grid container spacing={5} >
                                  <Grid item lg={6} md={6} xs={12}>
                                    <Typography align="center" variant="h3" >
                                      No hay solicitudes
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          }
                        </Container>
                        :
                        this.state.option == "resivedmsj" ?
                          <Container>
                            <br></br>
                            <Tooltip title="Crear mensaje" aria-label="add">
                              <Fab color="info" aria-label="add" onClick={event => this.handleOpen1()}>
                                <AddIcon />
                              </Fab>
                            </Tooltip>
                            <br></br>
                            <br></br>
                            <MaterialTable
                              actions={[
                                {
                                  icon: 'update',
                                  tooltip: 'Actualizar',
                                  isFreeAction: true,
                                  onClick: this.getMessages
                                }
                              ]}
                              title="Mis mensajes recibidos"
                              columns={this.props.admin ? this.state.columnreceived : this.state.columnreceived2}
                              data={this.state.mymsgsto}
                              onRowClick={(event, rowData) => this.handleOpenSettings(rowData)}
                              editable={{
                                onRowDelete: oldData =>
                                  new Promise(resolve => {
                                    setTimeout(() => {
                                      resolve();
                                      const data = [this.state.mymsgsto];
                                      data.splice(data.indexOf(oldData), 1);
                                      console.log("delete", oldData)
                                      this.setState({ mymsgsto: data });
                                      this.removeMessage(oldData)
                                    }, 600);
                                  }),
                              }}
                            />
                            <br></br>
                            <br></br>
                          </Container> :
                          this.state.option == "sendmsj" ?
                            <Container>
                              <br></br>
                              <br></br>
                              <Tooltip title="Crear mensaje" aria-label="add">
                              <Fab color="info" aria-label="add" onClick={event => this.handleOpen1()}>
                                <AddIcon />
                              </Fab>
                            </Tooltip>
                              <br></br>
                              <br></br>
                              <MaterialTable
                                actions={[
                                  {
                                    icon: 'update',
                                    tooltip: 'Actualizar',
                                    isFreeAction: true,
                                    onClick: this.getMessages
                                  }
                                ]}
                                title="Mis mensajes enviados"
                                columns={this.props.admin ? this.state.columnsend : this.state.columnsend2}
                                data={this.state.mymsgsfrom}
                                onRowClick={(event, rowData) => this.handleOpenSettings(rowData)}
                                editable={{
                                  onRowDelete: oldData =>
                                    new Promise(resolve => {
                                      setTimeout(() => {
                                        resolve();
                                        const data = [this.state.mymsgsfrom];
                                        data.splice(data.indexOf(oldData), 1);
                                        console.log("delete", oldData)
                                        this.setState({ mymsgsfrom: data });
                                        this.removeMessage(oldData)
                                      }, 600);
                                    }),
                                }}
                              />
                              <br></br>
                              <br></br>
                            </Container> :
                            null
              }
            </Grid>
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>{this.state.msgdiag}</h6></DialogTitle>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary" autoFocus>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={this.state.open1}
              onClose={this.handleClose1}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="10000"
            >
              <DialogTitle id="alert-dialog-title"><h5 style={{ color: '#676768' }}>Enviar Mensaje</h5></DialogTitle>
              <DialogContent  >
                {this.props.admin ?
                  <div>
                    <Form action="" className="form" method="">
                      <Grid container>
                        <Grid item xs={6} sm container>
                          <FormControl variant="outlined" >
                            Empresa:
                        <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={this.state.toemps}
                              onChange={this.handleChangetype('toemps')}
                              labelWidth={500}
                            >
                              {this.state.emps.map(option => (
                                <MenuItem key={option} value={option}>
                                  <em>{option.name}</em>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6} sm container>
                          {this.state.enableto ?
                            <FormControl variant="outlined" >
                              Para:
                          <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={this.state.tosend}
                                onChange={this.handleChangetype('tosend')}
                                labelWidth={500}
                              >
                                {this.state.filterusers.map(option => (
                                  <MenuItem key={option} value={option}>
                                    <em>{option.name}</em>
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>

                            : null
                          }

                        </Grid>
                      </Grid>
                      {this.state.enablemsg ?
                        <div>
                          <InputGroup
                            className={
                              "no-border input-lg" +
                              (this.state.firstFocus ? " input-group-focus" : "")
                            }
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="now-ui-icons users_circle-08"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Asunto"
                              type="text"
                              value={this.state.subject || ''}
                              onChange={this.handleChangetype('subject')}
                              onFocus={() => this.setState({ firstFocus: true })}
                              onBlur={() => this.setState({ firstFocus: false })}
                              style={{ fontSize: "15px", }}
                            ></Input>
                          </InputGroup>
                          <CKEditor
                            editor={ClassicEditor}
                            data={this.state.msgtosend}
                            config={{
                              uiColor: '#5f7d99',
                            }}
                            onInit={editor => {
                              // You can store the "editor" and use when it is needed.
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              this.setState({ msgtosend: data })
                            }}
                            onBlur={editor => {
                              console.log('Blur.', editor);
                            }}
                            onFocus={editor => {
                              console.log('Focus.', editor);
                            }}
                          />
                        </div>
                        : null}
                    </Form>
                  </div> :
                  <div>
                    <FormControl variant="outlined" >
                      Para:
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={this.state.tosend}
                        onChange={this.handleChangetype('tosend')}
                        labelWidth={500}
                      >
                        {this.state.filteradmins.map(option => (
                          <MenuItem key={option} value={option}>
                            <em>{option.name}</em>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <InputGroup
                      className={
                        "no-border input-lg" +
                        (this.state.firstFocus ? " input-group-focus" : "")
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons users_circle-08"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Asunto"
                        type="text"
                        value={this.state.subject || ''}
                        onChange={this.handleChangetype('subject')}
                        onFocus={() => this.setState({ firstFocus: true })}
                        onBlur={() => this.setState({ firstFocus: false })}
                        style={{ fontSize: "15px", }}
                      ></Input>
                    </InputGroup>
                    <CKEditor
                      editor={ClassicEditor}
                      data={this.state.msgtosend}
                      config={{
                        uiColor: '#5f7d99',
                      }}
                      onInit={editor => {
                        // You can store the "editor" and use when it is needed.
                        console.log('Editor is ready to use!', editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ msgtosend: data })
                      }}
                      onBlur={editor => {
                        console.log('Blur.', editor);
                      }}
                      onFocus={editor => {
                        console.log('Focus.', editor);
                      }}
                    /></div>}
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose1} color="primary" autoFocus>
                  Cancelar
                </Button>
                {this.state.correorec !== "" ?
                  <Button onClick={this.handleSave} color="primary" autoFocus>
                    Enviar
              </Button>
                  : null
                }
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.open2}
              onClose={this.handleClose2}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="10000"
            >
              <DialogTitle id="alert-dialog-title"><Typography variant="h4" component="h5">
                Asunto:{this.state.mailselected.subject}
              </Typography></DialogTitle>
              <DialogContent  >
                {this.state.mailselected.tomail !== this.props.user.mail ?

                  <List>
                    <ListItem button>
                      <ListItemText primary=
                        {
                          <div>
                            <Typography variant="h4" component="h5">
                              Para:
                            </Typography>
                            <TextField
                              id="standard-read-only-input"
                              label="Empresa"
                              defaultValue={this.state.empselected}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            <TextField
                              id="standard-read-only-input"
                              label="Nombre usuario:"
                              defaultValue={this.state.nameselected}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            <TextField
                              id="standard-read-only-input"
                              label="Correo:"
                              defaultValue={this.state.mailselected.tomail}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </div>
                        } />
                    </ListItem>
                    <Divider />
                    <Card style={{ width: "100%", heigth: "100%" }}>
                      <CardContent>
                        <div dangerouslySetInnerHTML={{ __html: this.state.mailselected.msg }} />
                      </CardContent>
                    </Card>
                  </List>

                  : <List>
                    <ListItem button>

                      <ListItemText primary=
                        {
                          <div>
                            <Typography variant="h4" component="h5">
                              De:
                              </Typography>
                            {this.state.mailselected.from.profile !== "admin" ?
                              <TextField
                                id="standard-read-only-input"
                                label="Empresa"
                                defaultValue={this.state.empselected}
                                InputProps={{
                                  readOnly: true,
                                }}
                              /> : null
                            }

                            <TextField
                              id="standard-read-only-input"
                              label="Nombre usuario:"
                              defaultValue={this.state.mailselected.from.name}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                            <TextField
                              id="standard-read-only-input"
                              label="Correo:"
                              defaultValue={this.state.mailselected.frommail}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </div>
                        } />
                    </ListItem>
                    <Divider />
                    <Card style={{ width: "100%", heigth: "100%" }}>
                      <CardContent>
                        <div dangerouslySetInnerHTML={{ __html: this.state.mailselected.msg }} />
                      </CardContent>
                      <CardActions>
                        <div>
                          <Tooltip title="Responder" aria-label="add">
                            <Fab variant="extended" onClick={() => this.setState({ openrespond: true, tosend: this.state.mailselected.from, toemps: this.state.mailselected.emp })}>
                              <CallMadeIcon />
                            </Fab>
                          </Tooltip>
                        </div>
                      </CardActions></Card>
                    {this.state.openrespond ?
                      <div>
                        <Divider />
                        <br></br>
                        <Card>
                          <CardContent>
                            <div>
                              <InputGroup
                                className={
                                  "no-border input-lg" +
                                  (this.state.firstFocus ? " input-group-focus" : "")
                                }
                              >
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="now-ui-icons users_circle-08"></i>
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  placeholder="Asunto"
                                  type="text"
                                  value={this.state.subject || ''}
                                  onChange={this.handleChangetype('subject')}
                                  onFocus={() => this.setState({ firstFocus: true })}
                                  onBlur={() => this.setState({ firstFocus: false })}
                                  style={{ fontSize: "15px", }}
                                ></Input>
                              </InputGroup>
                              <CKEditor
                                editor={ClassicEditor}
                                data={this.state.msgtosend}
                                config={{
                                  uiColor: '#5f7d99',
                                }}
                                onInit={editor => {
                                  // You can store the "editor" and use when it is needed.
                                  console.log('Editor is ready to use!', editor);
                                }}
                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  this.setState({ msgtosend: data })
                                }}
                                onBlur={editor => {
                                  console.log('Blur.', editor);
                                }}
                                onFocus={editor => {
                                  console.log('Focus.', editor);
                                }}
                              />
                              <Tooltip title="Enviar" aria-label="add">
                                <Fab variant="extended" onClick={this.handleSave}>
                                  <SendIcon />
                                </Fab>
                              </Tooltip>
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                      : null}
                  </List>
                }
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose2} color="primary" autoFocus>
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.open3}
              onClose={this.handleClose3}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              minWidth="2000"
              maxWidth="10000"
            >
              <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>Pregunta</h6></DialogTitle>
              <DialogContent>
                <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                  <InputLabel >Descripción corta</InputLabel>
                  <OutlinedInput
                    value={this.state.descorta}
                    onChange={this.handleChangetype('descorta')}
                    labelWidth={60}
                    disabled={this.state.showques ? true : false}
                  />
                </FormControl>
                <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                  <TextField
                    id="outlined-multiline-static"
                    fullWidth
                    value={this.state.deslarga}
                    label="Descripción larga"
                    onChange={this.handleChangetype('deslarga')}
                    multiline
                    variant="outlined"
                    rows="4"
                    InputProps={{
                      readOnly: this.state.showques ? true : false,
                    }}
                  />
                </FormControl>
                <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                  <TextField
                    id="outlined-multiline-static"
                    fullWidth
                    value={this.state.respuesta}
                    label="Respuesta"
                    onChange={this.handleChangetype('respuesta')}
                    multiline
                    rows="10"
                    variant="outlined"
                    InputProps={{
                      readOnly: this.state.showques ? true : false,
                    }}
                  />
                </FormControl>
              </DialogContent>
              <DialogActions>
                {this.state.showques ?
                  <div>
                    <Button onClick={() => this.setState({ showques: false, newques: false })} color="primary" autoFocus>
                      Editar
                  </Button>
                    <Button onClick={this.handleRemoveQues} color="primary" autoFocus>
                      Eliminar
                       </Button>
                  </div>
                  :
                  <Button onClick={this.state.newques ? this.handleSaveQues : this.handleUpdateQues} color="primary" autoFocus>
                    Guardar
                  </Button>
                }

                <Button onClick={this.handleClose3} color="primary" autoFocus>
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.open4}
              onClose={this.handleClose4}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>Temas</h6></DialogTitle>
              <DialogContent>
                <MaterialTable
                  title=""
                  columns={this.state.columnstemas}
                  data={this.state.topics}
                  editable={{
                    onRowAdd: newData =>
                      new Promise(resolve => {
                        setTimeout(() => {
                          resolve();
                          const data = this.state.topics;
                          data.push(newData);
                          this.setState({ topics: data });
                          this.addingTopic(newData)
                        }, 600);
                      }),

                    onRowDelete: oldData =>
                      new Promise(resolve => {
                        setTimeout(() => {
                          resolve();
                          const data = [this.state.topics];
                          data.splice(data.indexOf(oldData), 1);
                          console.log("delete", oldData)
                          this.setState({ topics: data });
                          this.removeTopic(oldData)
                        }, 600);
                      }),
                  }}

                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose4} color="primary" autoFocus>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.open5}
              onClose={this.handleCloseFormulario}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
            >
              <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>Formulario cálculo de Pensión</h6></DialogTitle>
              <DialogContent>
                <TextField disabled={true} id="outlined-basic" label="Nombre:" variant="outlined" value={this.state.name} style={{ margin: 9, minWidth: 300 }} />
                <TextField disabled={true} id="outlined-basic" label="Cédula" variant="outlined" value={this.state.cc} style={{ margin: 9, minWidth: 200 }} />
                <TextField disabled={true} id="outlined-basic" label="E-mail" variant="outlined" value={this.state.mail} style={{ margin: 9, minWidth: 200 }} />
                <TextField disabled={true} id="outlined-basic" label="Empresa" variant="outlined" value={this.state.emp} style={{ margin: 9, minWidth: 150 }} />
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Celular" variant="outlined" value={this.state.celular} style={{ margin: 9, minWidth: 150 }} onChange={this.handleChangetype('celular')} />
                <FormControl variant="outlined" style={{ margin: 9, minWidth: 120 }}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    Género
                  </InputLabel>
                  <Select
                    disabled={this.state.showform ? true : null}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={this.state.genero}
                    onChange={this.handleChangetype('genero')}
                  >
                    <MenuItem value="Femenino">Femenino</MenuItem>
                    <MenuItem value="Masculino">Masculino</MenuItem>
                  </Select>
                </FormControl>
                <Divider />
                <FormControl variant="outlined" style={{ margin: 9, minWidth: 390 }}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    Fondo
                  </InputLabel>
                  <Select
                    disabled={this.state.showform ? true : null}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={this.state.fondo}
                    onChange={this.handleChangetype('fondo')}
                  >
                    <MenuItem value="Privado">Privado</MenuItem>
                    <MenuItem value="Colpensiones">Colpensiones</MenuItem>
                  </Select>
                </FormControl>
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="¿Cúal régimen pensional le conviene más?" variant="outlined" value={this.state.regimen} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('regimen')} />
                <FormControl variant="outlined" style={{ margin: 9, minWidth: 390 }}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    ¿Desea pensionarse tempranamente?
                  </InputLabel>
                  <Select
                    disabled={this.state.showform ? true : null}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={this.state.pensiontemprana}
                    onChange={this.handleChangetype('pensiontemprana')}
                  >
                    <MenuItem value="si">Sí</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Semanas cotizadas hasta la fecha" variant="outlined" value={this.state.semanas} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('semanas')} />
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Saldo cuenta de ahorros individual" variant="outlined" value={this.state.cuenta} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('cuenta')} />
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Saldo aportes voluntarios" variant="outlined" value={this.state.voluntarios} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('voluntarios')} />
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Saldo aportes voluntarios dentro de PO" variant="outlined" value={this.state.volutariospo} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('volutariospo')} />
                <FormControl disabled={this.state.showform ? true : null} variant="outlined" style={{ margin: 9, minWidth: 390 }}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    ¿Capitaliza, regularmente, rendimientos?
                  </InputLabel>
                  <Select
                    disabled={this.state.showform ? true : null}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={this.state.capitaliza}
                    onChange={this.handleChangetype('capitaliza')}
                  >
                    <MenuItem value="si">Sí</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
                <FormControl variant="outlined" style={{ margin: 9, minWidth: 390 }}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    ¿Blinda, regularmente, rendimientos?
                  </InputLabel>
                  <Select
                    disabled={this.state.showform ? true : null}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={this.state.blinda}
                    onChange={this.handleChangetype('blinda')}
                  >
                    <MenuItem value="si">Sí</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>

                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Ingreso Base de Cotización(Salario mensual)" variant="outlined" value={this.state.salario} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('salario')} />
                <TextField disabled={this.state.showform ? true : null} id="outlined-basic" label="Valor Bono Pensional" variant="outlined" value={this.state.bono} style={{ margin: 9, minWidth: 390 }} onChange={this.handleChangetype('bono')} />
                {this.props.admin ?
                  <FormControl variant="outlined" style={{ margin: 9, minWidth: 280 }}>
                    <InputLabel htmlFor="outlined-age-native-simple">
                      Estado
                    </InputLabel>
                    <Select
                      disabled={this.state.showform ? true : null}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={this.state.statusreq}
                      onChange={this.handleChangetype('statusreq')}
                    >
                      <MenuItem value="Creado">Creado</MenuItem>
                      <MenuItem value="Recibido">Recibido</MenuItem>
                    </Select>
                  </FormControl>
                  :
                  <TextField disabled={true} id="outlined-basic" label="Estado" variant="outlined" value={this.state.statusreq} style={{ margin: 9, minWidth: 260 }} />}
              </DialogContent>
              <DialogActions>
                {this.state.showform ?
                  <div>
                    <Button onClick={() => this.setState({ showform: false, newform: false })} color="primary" autoFocus>
                      Editar
                  </Button>
                    {!this.props.admin ?
                      <Button onClick={this.handleRemoveReq} color="primary" autoFocus>
                        Eliminar
                     </Button>
                      : null}
                  </div>
                  :
                  <Button onClick={this.state.newform ? this.handleSaveReq : this.handleUpdateReq} color="primary" autoFocus>
                    Guardar
                  </Button>
                }
                <Button onClick={this.handleCloseFormulario} color="primary" autoFocus>
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.open6}
              onClose={this.handleClose6}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              minWidth="2000"
              maxWidth="10000"
            >
              <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>Producto</h6></DialogTitle>
              <DialogContent>
                <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                  <InputLabel>Nombre producto</InputLabel>
                  <OutlinedInput
                    value={this.state.nameproduct}
                    onChange={this.handleChangetype('nameproduct')}
                    labelWidth={60}
                    disabled={this.state.showprod ? true : false}
                  />
                </FormControl>
                <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                  <TextField
                    id="outlined-multiline-static"
                    fullWidth
                    value={this.state.desproduct}
                    label="Descripción"
                    onChange={this.handleChangetype('desproduct')}
                    multiline
                    rows="10"
                    variant="outlined"
                    InputProps={{
                      readOnly: this.state.showprod ? true : false
                    }}
                  />
                </FormControl>
              </DialogContent>
              <DialogActions>
                {this.state.showprod ?
                  <div>
                    <Button onClick={() => this.setState({ showprod: false, newprod: false })} color="primary" autoFocus>
                      Editar
                  </Button>
                    <Button onClick={this.removeProduct} color="primary" autoFocus>
                      Eliminar
                       </Button>
                  </div>
                  :
                  <Button onClick={this.state.newprod ? this.handleSaveProduct : this.handleUpdateProduct} color="primary" autoFocus>
                    Guardar
                  </Button>
                }

                <Button onClick={this.handleClose6} color="primary" autoFocus>
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
        <DarkFooter />
      </div>
    );
  }
}

export default Options;